export default {
  FEATURE_ADD: 'feature_add',
  FEATURE_EDIT: 'feature_edit',
  FEATURE_DELETE: 'feature_delete',
  FEATURE_TOGGLE: 'feature_toggle'
};
